import History from "./GlobalNavigation/navigationHistory";
import store from "../../store/store";
import { addEmailToBrevo, sign_message_web3auth, verifyWeb3authEmail, web3auth } from "./web3auth";
import { clearStore } from "../../store/StoreService";
import { authAC } from "../../store/action-creators";
import { sign_message_metamask } from "./evm";
import { solana_sign_message } from "./solana";
import { cosmos_sign_message } from "./coreum";
import { radix_sign_message } from "./radix";
import axios from "axios";
import { baseUrl } from "../config/urls";
import { notify } from "./notification";


const ADMIN_ADDRESS: string[] = process.env.REACT_APP_ADMIN_ADDRESS
  ? process.env.REACT_APP_ADMIN_ADDRESS.split(',')
  : [];

export const proceedLogin = async (
  Blockchain: string,
  loginType: string | undefined,
  loginRediect:string,
  setIsLoading?:any,
  cosmoskitDialog?:any
) => {
  let obj = null;
  let authToken = null;
  let jwtAuthToken = null;
  try {
    switch (Blockchain) {
      case "EVM":
        obj =
          loginType === "metamask"
            ? await sign_message_metamask()
            : await sign_message_web3auth();
        break;
      case "Solana":
        obj = await solana_sign_message();
        break;
      case "Coreum":
        obj = await cosmos_sign_message();
        cosmoskitDialog.closeView();
        break;
      case "Radix":
        obj = await radix_sign_message();
        break;
      default:
        obj = await sign_message_metamask();
        break;
    }
    authToken = await axios.post(`${baseUrl}/api/auth/verify_signer`, {
      publicKey: obj?.address,
      signedMessage: obj?.signed_message,
    });
  login(
    obj?.address || "",
    Blockchain === "Coreum" ? obj?.alternativeAddress : obj?.address,
    obj?.signed_message,
    authToken?.["data"]?.["accessToken"],
    authToken?.["data"]?.["refreshToken"],
    jwtAuthToken?.["data"]?.["token"] || undefined,
    jwtAuthToken?.["data"]?.["refreshToken"] || undefined,
    loginRediect,
    Blockchain,
    loginType
  );
  } catch {
    notify(`Something went wrong`, "error");
  }
  setIsLoading(false);
};




export async function login(
  address: string | undefined,
  altAddress: string | undefined = undefined,
  signedMessage: string | undefined,
  accessToken: string | undefined,
  refreshToken: string | undefined,
  jwtToken: string | undefined,
  jwtRefreshToken: string | undefined,
  redirect: string | undefined = "/dashboard",
  blockchain: string | undefined,
  loginType: string | undefined
): Promise<void> {
  const expirationDate = new Date();
  expirationDate.setDate(expirationDate.getDate() + 7);
  await store.dispatch<any>(
    authAC.setAuthData({
      userAddress: address,
      altAddress:altAddress,
      expirationDate: expirationDate,
      signedMessage: signedMessage,
      accessToken: accessToken,
      refreshToken: refreshToken,
      blockchain: blockchain,
      JWT: jwtToken,
      JWTrefreshToken: jwtRefreshToken,
      JWTexpiry: expirationDate,
      loginType: loginType,
    })
  );

  (async () => {
    if(getLoginType() === 'openlogin')await verifyWeb3authEmail();
    await addEmailToBrevo();
  })();

  if (History) {
    window.location.pathname !== redirect
      ? History?.navigate?.(redirect)
      : window.location.reload();
  }
}

export function isLogin(stateData: any = null): boolean {
  const authData = store?.getState()?.["auth"];
  if (
    authData?.["userAddress"] &&
    authData?.["expirationDate"] &&
    authData?.["signedMessage"] &&
    authData?.["accessToken"]
  ) {
    const currentDate = new Date();
    const expirationDate = new Date(authData?.["expirationDate"]);
    return expirationDate.getTime() > currentDate.getTime();
  } else {
    return false;
  }
}


export function isAdminLogin():boolean {
  if(getBlockchainType() === "EVM"){
    const currentAddress = getAddress();
    return currentAddress ? ADMIN_ADDRESS.includes(currentAddress) : false;
  }
  return false;
}

export async function logout(stateData: any = null): Promise<void> {
  if (web3auth?.connected) {
    await web3auth.logout();
  }

  if(getBlockchainType() === "Coreum"){
    try {
      const providerData = store?.getState()?.["currentProvider"];
      await providerData?.cosmoskitDisconnect();
    } catch (error) {
      
    }
  }
  if(getBlockchainType() === "Radix"){
    try {
      const rdt = store?.getState()?.["currentProvider"]?.radixDappToolkit;
      await rdt?.disconnect();
    } catch (error) {
      
    }
  }
  
  await clearStore();

  History.push("/", { state: stateData ? stateData : { from: "logout" } });
}

export function getLockedUserStatus(): boolean {
  const isOlderThanThirtyDays = store?.getState()?.otherData?.isOlderThanThirtyDays || false;
  return false;  
}

export function getAddress(): string | null {
  let address = null;
  if (isLogin()) {
    address = store?.getState()?.["auth"]?.["userAddress"];
  }
  return address;
}

export function getAltAddress():string|null {
  let address = null;
  if (isLogin()) {
    address = store?.getState()?.["auth"]?.["altAddress"];
  }
  return address;
}

export function getBlockchainType(): string | null {
  let blockchain = null;
  if (isLogin()) {
    blockchain = store?.getState()?.["auth"]?.["blockchain"];
  }
  return blockchain;
}

export function getLoginType(): string | null {
  let loginType = null;
  if (isLogin()) {
    loginType = store?.getState()?.["auth"]?.["loginType"];
  }
  return loginType;
}

export function getSignMessage(): string | null {
  let message = null;
  if (isLogin()) {
    message = store?.getState()?.["auth"]?.["signedMessage"];
  }
  return message;
}

export function getAccessToken(): string | null {
  let message = null;
  if (isLogin()) {
    message = store?.getState()?.["auth"]?.["accessToken"];
  }
  return message;
}

export function getRefreshToken(): string | null {
  let message = null;
  if (isLogin()) {
    message = store?.getState()?.["auth"]?.["refreshToken"];
  }
  return message;
}
